import React, {useState} from 'react';
import { connect } from "react-redux";
import {
    CardBody,
    Col, Form, FormGroup, Input, Label, Row,
} from 'reactstrap';
import Switch from "react-bootstrap-switch";
import {
    ButtonClean,
    ButtonSearch,
} from "../../../components/buttons/buttonsActions";
import {FL_CODE} from "../../../components/i18n/formLabels";
import {setFilter} from "../../../redux/actions/generalActions/listActions";
import {useForm} from "react-hook-form";


const LegalFilter = (props) => {
    const { filter } = props.listProps
    const { app } = props.mainProps

    const fbDataBaseId = app?.fbDataBase?.id

    const [onlyRegistered, setOnlyRegistered] = useState(true);

    const { register, handleSubmit, reset } = useForm({
        defaultValues: {
            code: filter?.item?.code,
        }
    });

    const cleanFields = () => {
        const tmpFilter = JSON.parse(JSON.stringify(filter))
        if(tmpFilter && tmpFilter.item){
            delete tmpFilter.item.onlyRegistered;
        }
        props.setFilter(tmpFilter);
        reset({
            code: '',
        })
        setOnlyRegistered(true)
    }

    const onSubmit = (data, _) => {
        if(!fbDataBaseId)
            return

        const dataFilter = {
            fbDataBase : {  id : fbDataBaseId },
            onlyRegistered : onlyRegistered,
            item : {
                ...data,
            }
        }

        props.setFilter(dataFilter);
    };

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <CardBody className="">
                <Row>
                    <Col md="3">
                        <Label>{FL_CODE}</Label>
                        <Input
                            type="text" name="code"
                            innerRef={register}
                        />
                    </Col>
                    <Col md="1">
                        <FormGroup>
                            <Label>Solo en app</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={onlyRegistered}
                                onChange={ () => setOnlyRegistered(!onlyRegistered) }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3" className="d-flex align-items-center">
                        <div >
                            <ButtonSearch/>
                            <ButtonClean onClick={() => cleanFields()}/>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Form>
    )
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    listProps: state.listProps,
})

const mapActionsToProps = ({
    setFilter,
})

export default connect(mapStateToProps, mapActionsToProps)(LegalFilter)